module.exports = __webpack_public_path__ + "static/img/LaurenJackson.5134354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LaurenJackson.jpg
// module id = Ysa2
// module chunks = 0